import {
  FaFacebook,
  FaGithub,
  FaGitlab,
  FaLinkedin,
  FaTwitter,
} from "react-icons/fa";

export const data = [
  {
    platform: "Facebook",
    icon: <FaFacebook />,
    link: "https://https://www.facebook.com/fred.vuni.1",
  },
  {
    platform: "Git",
    icon: <FaGithub />,
    link: "https://github.com/FREDVUNI/",
  },
  {
    platform: "Gitlab",
    icon: <FaGitlab />,
    link: "https://gitlab.com/FREDVUNI",
  },
  {
    platform: "Linkedin",
    icon: <FaLinkedin />,
    link: "https://www.linkedin.com/in/fred-vuni-3028a721b/?originalSubdomain=ug",
  },
  {
    platform: "Twitter",
    icon: <FaTwitter />,
    link: "https://x.com/VuniFred",
  },
];
